import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../../app/globals.css';

import { AuthProvider } from '@/hooks/auth-context';
import { ModalLoginProvider } from '@/hooks/modal-context';
import { CartProvider } from '@/hooks/cart-context';
import { VideoModalProvider } from '@/hooks/video-modal-context';

import PetIDPage from '@/app/petid/page';

function App() {
  return (
    <AuthProvider>
      <ModalLoginProvider>
        <CartProvider>
          <VideoModalProvider>
            <PetIDPage />
          </VideoModalProvider>
        </CartProvider>
      </ModalLoginProvider>
    </AuthProvider>
  );
}

const mountEl = document.getElementById('petid-root');
if (mountEl) {
  createRoot(mountEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  // eslint-disable-next-line no-console
  console.warn('[babalu-petid] Missing #petid-root mount element');
}

